<template>
  <div v-show="pageShow"
       class="page">
    <ul class="pagination">
      <li v-if="first">
        <a @click="gotoPage(1,$event)"
           :class="{disabled:pageCurrent === 1}">
          <span>首页</span>
        </a>
      </li>
      <li v-if="previous">
        <a v-if="pageCurrent === 1"
           class="disabled">
          <span>{{prevText}}</span>
        </a>
        <a @click="gotoPage(pageCurrent-1,$event)"
           v-else>
          <span>{{prevText}}</span>
        </a>
      </li>
      <template v-for="(page, i) in pageTotal">
        <li v-show="itemShow(page)"
            :key="i">
          <a @click="gotoPage(page,$event)"
             :class="{bold:page === pageCurrent}">{{page}}</a>
        </li>
      </template>
      <li v-if="next">
        <a v-if="pageCurrent === pageTotal"
           class="disabled">
          <span>></span>
        </a>
        <a @click="gotoPage(pageCurrent+1,$event)"
           v-else>
          <span>></span>
        </a>
      </li>
      <li v-if="last">
        <a @click="gotoPage(pageTotal,$event)"
           :class="{disabled:pageCurrent === pageTotal}">
          <span>尾页</span>
        </a>
      </li>
      <li class="total_count">共{{totalCount}}条</li>
      <li class="page_count">共{{pageTotal}}页，</li>
      <li v-if="jump"
          class="page_num">
        到第&nbsp;
        <input type="text"
               class="currPage"
               v-model="pageNum"
              >&nbsp;页
        <div @click="gotoPage(pageNum,$event)"
                class="page-sure-btn">确定
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "Page",
    props: ["paging"],
    data() {
      return {
        pageNum: Math.ceil((this.paging.start + 1) / this.paging.prePage),
        prevText: '<',
        nextText: '>'
      };
    },
    computed: {
      totalCount() {
        return this.paging.total;
      },
      pageTotal: function () {
        return Math.ceil(this.paging.total / this.paging.prePage);
      },
      pageShow: function () {
        return Boolean(this.paging.total > 0);
      },
      pageCurrent: {
        set: function (page) {
          if (page < 1) {
            page = 1;
          } else if (page > this.pageTotal) {
            page = this.pageTotal;
          }
          this.paging.start = (page - 1) * this.paging.prePage;
        },
        get: function () {
          return Math.ceil((this.paging.start + 1) / this.paging.prePage);
        }
      },
      size: function () {
        return this.paging.size || 8;
      },
      previous: function () {
        return this.paging.previous == undefined ? true : this.paging.previous;
      },
      next: function () {
        return this.paging.next == undefined ? true : this.paging.next;
      },
      first: function () {
        return this.paging.first == undefined ? true : this.paging.first;
      },
      last: function () {
        return this.paging.last == undefined ? true : this.paging.last;
      },
      jump: function () {
        return this.paging.jump == undefined ? false : this.paging.jump;
      }
    },
    methods: {
      gotoPage: function (page, event) {
        if (event) {
          event.preventDefault();
        }
        if (this.pageCurrent != page) {
          if (page>this.pageTotal){
            this.$message.error('页码超出最大范围')
            return
          }
          this.$emit("goto-page", this.pageToStart(page));
        }
      },
      itemShow: function (page) {
        return (
          Math.abs(page - this.pageCurrent) < this.size ||
          (this.pageCurrent < this.size && page < 2 * this.size) ||
          (this.pageTotal - this.pageCurrent < this.size &&
            this.pageTotal - page < 2 * this.size)
        );
      },
      pageToStart: function (page) {
        if (page < 1) {
          page = 1;
        } else if (page > this.pageTotal) {
          page = this.pageTotal;
        }
        return (page - 1) * this.paging.prePage;
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';

  .page
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center
    user-select none

  .pagination
    display flex
    align-items center

  .pagination > li
    font-size $font_size_big

  /*.pagination > li.total_count
    display none*/

  .pagination > li.page_count
    display none

  /*.pagination > li.page_num*/
  /*  display none*/
  .page_num
    margin-left 30px
    .currPage
      width 60px
      padding 0 10px
      text-align center
      color $color_black
      background-color $color_white
    .page-sure-btn
      display inline-block
      height 25px
      line-height 25px
      padding 0 10px
      background-color $color_suc
      font-size 18px
      cursor pointer
      color $color_white
  .pagination > li > a
    padding 5px 10px
    color $color_white
    font-size $font_size_big
    background transparent
    border none
    cursor pointer

  .pagination > li > a.disabled
    cursor not-allowed

  .pagination > li > a.bold
    cursor text

  .pagination > li > a.bold
    color $color_suc

  .pagination > li > a.bold:hover
    color $color_suc

  .pagination > li > a:hover
    border none
    color $color_white
    background transparent
</style>
